import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Dashboard from "./pages/Dashboard";
import InquiryDetail from "./pages/InquiryDetail";
import PublicQuoteForm from "./pages/PublicQuoteForm";
import { APP_VERSION, isPublicOnlyHost } from "./config/domains";

function QuoteLinkRequired() {
  return (
    <div className="min-h-screen grid place-items-center bg-white px-4">
      <div className="max-w-md w-full border-2 border-zinc-900 p-8 text-center">
        <div className="label-overline mb-2">Transport Quote</div>
        <h1 className="text-2xl font-bold tracking-tight mb-2">
          Quote link required
        </h1>
        <p className="text-sm text-zinc-600">
          Open the quote request link shared with you to submit your rate.
        </p>
      </div>
    </div>
  );
}

function App() {
  const isQuoteOnlyDomain = isPublicOnlyHost(window.location.host);

  return (
    <div className="App" data-app-version={APP_VERSION}>
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={isQuoteOnlyDomain ? <QuoteLinkRequired /> : <Dashboard />}
          />
          <Route
            path="/inquiry/:id"
            element={isQuoteOnlyDomain ? <QuoteLinkRequired /> : <InquiryDetail />}
          />
          <Route path="/q/:token" element={<PublicQuoteForm />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
